export default {
    label_task:{
        en:"Diseases",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Disease",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Disease",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Disease",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_crop_id:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
    label_crop_name:{
        en:"Crop",
        bn:"কর্মচারী আইডি"
    },
    label_type:{
        en:"Type",
        bn:"প্রিফিক্স"
    },
}